module.exports = __webpack_public_path__ + "img/solution_banner.3c1c44b9.jpg";